import React, { useState, useEffect } from "react";
import axios from "axios";

const FilterCityData = ({tokenStorage,setcityDetailResponse,cityDetailResponse,setFilterCityData,filterCityData}) => {   
  const [countryResponse, setCountryResponse] = useState([]);
  const [stateResponse, setStateResponse] = useState([]);
  const [cityResponse, setCityResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [city,setCity]=useState("");

  const [formData, setFormData] = useState({    
       
        countryName:"",
        stateName:"",
        cityName:""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetFilterCityData?country=${formData.countryName}&state=${formData.stateName}&city=${city}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setcityDetailResponse(response.data.data);          
          setFilterCityData(!filterCityData);

           // Optionally, reset the form
      setFormData({
        countryName:"",
        stateName:"",
        cityName:""
      });
      setCity("");
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const getCountry = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    // console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          // console.log(response.data);
          setCountryResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching Country detail:", error);
        });
    }
  };

  const handleCountryChange = (e) => {
    formData.countryName = e.target.value;
    getState(e.target.value);
  };

  function getState(country_id) {
    if (country_id !== null && country_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETState?stateID=0&countryID=` + country_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {         
            setStateResponse(response.data.data);          
        });
    }
  }

  const handleStateChange = (e) => {
    
    formData.stateName = e.target.value;
    getCity(e.target.value);
  };

  function getCity(state_id) {
    if (state_id !== null && state_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {          
            setCityResponse(response.data.data);                
        });
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="cityDetail">
        <div className="city-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Search Country Name*</td>
              <td>Search State Name*</td>
              <td>Search city Name*</td>
            </tr>

            <tr>
              <td>
                <select 
                name="countryName"
                onChange={handleCountryChange}
                value={formData.countryName}
                className="dropdown-country"
                onClick={getCountry}>
                  <option className="dropdown-country" value="">
                    Select your option
                  </option>
                  {countryResponse.map((item)=>(
                  <option key={item.id} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>
              <td>
                <select name="stateName"
                className="dropdown-state"
                onChange={handleStateChange}
                value={formData.stateName}>
                  <option className="dropdown-state" value="">
                    Select your option
                  </option>
                  {stateResponse.map((item)=>(
                  <option key={item.state_id} value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
              </td>
              <td>
                
                <input
                  type="text"
                  id=""
                  name="cityName"
                  value={city}
                  onChange={(e)=>{setCity(e.target.value)}}
                  className="dropdown-state"
                  placeholder="Search City"
                />
                 
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addCity-button">
            <button
              type="submit" onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Search
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default FilterCityData;
